import { useState, useEffect } from "react";
import {
  FaCog,
  FaUsers,
  FaBox,
  FaShoppingCart,
  FaClipboardList,
  FaChartPie,
  FaBook,FaPlus,
  FaDoorOpen,FaCar,FaSearch,FaBiohazard,FaFistRaised
} from "react-icons/fa";
import { MdQrCodeScanner } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
const menuItems = [

  { name: "Personne Physique", icon: <FaUsers />, color: "bg-orange-500",page:"./usagers" },
  { name: "Institution", icon: <FaFistRaised />, color: "bg-green-500",page:"./vehicule" },
  { name: "ONG", icon: <FaBiohazard />, color: "bg-yellow-900",page:"./plaque" },

];

export default function MenuUsage() {


  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(new Date());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (

      <div className=" w-[80%] h-[70%]  flex flex-col items-center  text-white absolute mt-[10%] ml-[10%] p-9">
      <div className="grid grid-cols-5 gap-4 relative">
        {menuItems.map((item, index) => (
          <Link to={item.page} className="transition transform hover:scale-105  ">
         <motion.div
            key={index}
            initial={{ opacity: 0, scale: 0.8, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            className={`w-40 h-40 flex flex-col items-center justify-center rounded-xl shadow-lg cursor-pointer transition transform hover:scale-105 ${item.color}`}
          >
            <div className="text-4xl">{item.icon}</div>
            <span className="mt-2 text-center text-lg font-semibold">
              {item.name}
            </span>
            </motion.div>
          </Link>
        ))}
      </div>
      </div>

  );
}
